import styled from '@emotion/styled';
import React, { useState } from 'react';

import Modal from '~ComponentsImproved/Modal';
import NumberInput from '~ComponentsImproved/Numpad';
import Heading from '~ComponentsImproved/Typography/Heading';
import Calculate from '~/Assets/icons/calculate.svg';
import { useI18n } from '~Hooks';

const Digit = styled.div`
  width: 48px;
  height: 48px;
  background: #d5d7d8;
  border-radius: 4px;
  color: #1c232c;
  font-size: 24px;
  line-height: 48px;
  font-weight: bold;
  margin: 16px;
  display: inline-block;
  text-align: center;
`;

const ContentWrapper = styled.div`
  box-sizing: border-box;
  width: 240px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-flow: row wrap;
`;

const Header = styled.div`
  margin-bottom: 16px;
  z-index: 1;
`;

const Icon = styled.div`
  height: 32px;
  width: 32px;
  mask-image: url(${Calculate});
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #1c232c;
  display: inline-block;
  margin-top: 9px;
`;

// Props onSelect, onCancel
type Props = {
  onSelect: (n: number) => void;
  range: number[];
  onCancel?: () => void;
};

const SplitModal = ({ onSelect, range, onCancel }: Props) => {
  const { i18n } = useI18n();
  const [showNumberInput, setShowNumberInput] = useState(false);

  return (
    <Modal isShowing={true} hide={onCancel}>
      <Header>
        <Heading level={3} color="#fff">
          {i18n('Handy.Cheque.Split')}
        </Heading>
      </Header>
      <ContentWrapper>
        {range.map((n) => (
          <Digit
            key={n}
            onClick={(e) => {
              e.stopPropagation();
              onSelect(n);
            }}>
            {n}
          </Digit>
        ))}
        <Digit
          onClick={(e) => {
            e.stopPropagation();
            setShowNumberInput(true);
          }}>
          <Icon />
        </Digit>
      </ContentWrapper>
      {showNumberInput && (
        <NumberInput
          maxCount={2}
          onClose={() => setShowNumberInput(false)}
          onSubmit={(val: string) => onSelect(parseInt(val))}
        />
      )}
    </Modal>
  );
};

export default SplitModal;
